module.exports = __webpack_public_path__ + "img/software-systems.840d9970.webp";